/**
 * Get initials from a player object.
 * Uses first_name + last_name if available, otherwise first char of display_name.
 */
export function getInitials(player) {
  if (player?.first_name && player?.last_name) {
    return (player.first_name.charAt(0) + player.last_name.charAt(0)).toUpperCase()
  }
  const name = player?.display_name || player?.first_name || '?'
  return name.charAt(0).toUpperCase()
}

/**
 * Convert hex color to rgba with opacity
 */
export function hexToRgba(hex, opacity = 0.2) {
  const cleanHex = hex.replace('#', '')
  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

/**
 * Lighten a hex color by mixing with white
 */
export function lightenColor(hex, amount = 0.7) {
  const cleanHex = hex.replace('#', '')
  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  const newR = Math.round(r + (255 - r) * amount)
  const newG = Math.round(g + (255 - g) * amount)
  const newB = Math.round(b + (255 - b) * amount)

  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`
}

/**
 * Darken a hex color by mixing with black
 */
export function darkenColor(hex, amount = 0.3) {
  const cleanHex = hex.replace('#', '')
  const r = parseInt(cleanHex.slice(0, 2), 16)
  const g = parseInt(cleanHex.slice(2, 4), 16)
  const b = parseInt(cleanHex.slice(4, 6), 16)

  const newR = Math.round(r * (1 - amount))
  const newG = Math.round(g * (1 - amount))
  const newB = Math.round(b * (1 - amount))

  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`
}
